import React from 'react'
import { useAxios } from '../hooks/useAxios'
import { getUserOtherInfo } from '../api/getUserOtherInfo'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import Card from '../components/Card'
import Skeleton from 'react-loading-skeleton'
import TextField from '../components/TextField'
import { errorDict } from '../utils/errorDict'
import CheckboxSingle from '../components/CheckboxSingle'
import Btn from '../components/Btn'
import { updateUserOtherInfo } from '../api/updateUserOtherInfo'

function ProfileEditFeaturesPage(): React.ReactElement {
  const { loading, fire, response, error } = useAxios()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isDirty }
  } = useForm()
  const { loading: submitLoading, fire: submitFire } = useAxios()

  React.useEffect(() => {
    void fire(getUserOtherInfo()).then(({ error, response }) => {
      if (error) {
        toast.error(error.message)
      } else {
        const data = response?.data ?? {}
        Object.keys(data).forEach((key) => {
          setValue(key, data[key])
        })
      }
    })
  }, [])

  const onSubmit = async (data: any): Promise<void> => {
    const { error } = await submitFire(updateUserOtherInfo(data))

    if (error) {
      toast.error(error.message)
    } else {
      toast.success('Изменения успешно сохранены')
    }
  }

  return (
    <>
      {loading || !error ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <header className={'card-head text-h3 d-block'}>
              {loading ? (
                <Skeleton width={'25%'}></Skeleton>
              ) : (
                'Личная информация'
              )}
            </header>
            <div className={'card-content'}>
              {loading ? (
                <Skeleton count={1} height={'10rem'}></Skeleton>
              ) : (
                <TextField
                  helpText={'Максимум 6000 символов'}
                  textarea
                  label={'О себе'}
                  rules={{ maxLength: 6000 }}
                  hasError={!!errors.about}
                  errorText={errorDict(errors.about)}
                  name={'about'}
                  control={control}
                ></TextField>
              )}
            </div>
          </Card>
          <Card className={'mt-md-5 mt-sm-4'}>
            <header className={'card-head text-h3 d-block'}>
              {loading ? <Skeleton width={'25%'}></Skeleton> : 'Интересы'}
            </header>
            <p className={'card-subtitle'}>
              {loading ? (
                <Skeleton width={'35%'}></Skeleton>
              ) : (
                'Выберите несколько направлений'
              )}
            </p>
            {loading ? (
              <ul className={'card-content features-list'}>
                {Array.from({ length: 6 }).map((_, index) => {
                  return (
                    <li key={index}>
                      <Skeleton width={'90%'}></Skeleton>
                    </li>
                  )
                })}
              </ul>
            ) : (
              <ul className={'card-content features-list'}>
                {Object.keys(response?.data?.features ?? {}).map(
                  (key: string) => {
                    return (
                      <li key={key}>
                        <CheckboxSingle
                          name={`features.${key}`}
                          control={control}
                          hideDetails
                        >
                          {key}
                        </CheckboxSingle>
                      </li>
                    )
                  }
                )}
              </ul>
            )}
          </Card>
          <Btn
            className={'mt-md-8 mt-sm-6'}
            disabled={!isDirty || submitLoading}
            loading={submitLoading}
            type={'submit'}
          >
            Сохранить изменения
          </Btn>
        </form>
      ) : (
        <>{error.message}</>
      )}
    </>
  )
}

export default ProfileEditFeaturesPage
